export default __webpack_public_path__ + "static/media/bg-tile-3.2b1696fd.webp";